<template>
  <div>

    <TitlePage :title="$t('cancellations')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile class="filter-card">
      <v-row class="px-4 pt-3 align-center">
        <v-col cols="12" md="6">
          <v-text-field
              v-model="filter.customer_q"
              :label="$t('customer') + ' (Nome/Cognome)'"
              clearable dense outlined hide-details
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              :items="refundTypeItems"
              label="Tipo rimborso"
              item-text="text" item-value="value"
              v-model="filter.refund_type"
              clearable dense outlined hide-details
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              :items="statuses"
              label="Stato"
              item-text="text" item-value="value"
              v-model="filter.status"
              clearable dense outlined hide-details
          />
        </v-col>
      </v-row>

      <v-row class="px-4 pb-3 align-center">
        <v-col cols="12" md="6">
          <DateRangeQuick
              v-model="createdFilter"
              :label="$t('creation_date')"
              @change="onCreatedChange"
          />
        </v-col>

        <v-spacer />

        <v-col cols="12" md="3" class="text-right">
          <v-btn small color="error" @click="resetFilter">
            <v-icon left small>mdi-restore</v-icon> RESET
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.booking="{ item }">
          <router-link target="_blank" rel="noopener"
              v-if="item.booking && item.booking[0]"
              :to="`/bookings/edit/${item.booking[0]._id}`"
          >
            <strong>{{ item.booking[0].code }}</strong>
          </router-link>
          <strong v-else>{{ '' }}</strong>
        </template>


        <template v-slot:item.customer="{ item }">
          <template v-if="item.customer[0]">
            <template v-if="isSuperAdmin">
              <router-link
                  v-if="item.customer[0]._id"
                  :to="`/customers/details/${item.customer[0]._id}`"
                  target="_blank"
                  rel="noopener"
              >
                <strong>{{ item.customer[0].name }} {{ item.customer[0].surname }}</strong>
              </router-link>
            </template>
            <template v-else>
              {{ item.customer[0].name }} {{ item.customer[0].surname }}
            </template>
          </template>
          <template v-else-if="item.note">
            {{item.note}}
          </template>
          <template v-else>
            N.D.
          </template>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small :color="getStatus(item.status, 'color')">{{ getStatus(item.status, 'name') }}</v-chip>
        </template>


        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleString() }}
        </template>

        <template v-slot:item.refund.type="{ item }">
          {{ getTypeCancellation(item.refund.type) }}
        </template>

        <template v-slot:item.refund.value="{ item }">
          {{ (item.refund.value.toFixed(2)) }} €
        </template>

        <template v-slot:item.hours_before="{ item }">
          <v-chip v-if="item.hours_before < 36" small color="error">{{ item.hours_before }} h</v-chip>
          <v-chip v-else small>{{ item.hours_before }} h</v-chip>
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>

            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="primary">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="edit(item._id)" :title="$t('edit')" dense>
                <v-list-item-title>
                  <v-icon dense color="primary" class="mr-3">mdi-file-edit</v-icon>
                  Visualizza/Gestisci
                </v-list-item-title>
              </v-list-item>
<!--              <v-list-item @click="confirmRemove(item._id)" :title="$t('delete')">-->
<!--                <v-list-item-title>-->
<!--                  <v-icon dense color="primary" class="mr-3">mdi-delete</v-icon>-->
<!--                  {{ $t('delete') }}-->
<!--                </v-list-item-title>-->
<!--              </v-list-item>-->
            </v-list>
          </v-menu>
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3" v-if="items_count > 0">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>

    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import DateRangeQuick from "@/components/filters/DateRangeQuick.vue";

const exportService = require('@/services/export')

export default {
  name: 'Cancellations',
  components: {DateRangeQuick, ItemActions, ModalDelete, TitlePage},
  data() {
    return {
      pathCreate: '/cancellations/create/',
      pathEdit: '/cancellations/edit/',
      search: '',
      selected: [],
      headers: [
        // { text: this.$t('Id'), align: 'start', value: '_id'},
        {text: this.$t('code'), align: 'start', value: 'booking'},
        {text: this.$t('customer'), align: 'start', value: 'customer'},
        {text: this.$t('status'), value: 'status', sortable: false},
        {text: this.$t('type') +' '+this.$t('refund'), value: 'refund.type', sortable: false},
        {text: this.$t('hours_before'), value: 'hours_before', sortable: false},
        {text: this.$t('amount'), value: 'refund.value', sortable: false},
        {text: this.$t('creation_date'), value: 'created_at'},
        {text: this.$t('actions'), align: 'start', value: 'action', sortable: false},
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      statuses: [
        {text: "", value: ""},
        {text: "Completata", value: "completed"},
        {text: "In Attesa", value: "pending"},
      ],
      refundTypeItems: [
        { text: 'Tutti',        value: null },
        { text: 'Nessuno',      value: 'nothing' },
        { text: 'Importo Fisso',value: 'fixed' },
        { text: 'Promo Code',   value: 'promo_code' },
      ],
      filter: {
        status : null,
        refund_type: null,
        customer_q: null,
        created_from: null,
        created_to: null,
      },
      createdFilter: { from: null, to: null },
      options_pagination: {
        page: 1,
        limit: 10
      },
      items_for_page:[10, 20, 25, 50, 75, 100],
      _debouncedSearch: null,
    };
  },
  async created() {
    this.filter = Object.assign({
      status: null, refund_type: null, customer_q: null, created_from: null, created_to: null
    }, this.getFilter || {});

    this.options_pagination = Object.assign({}, this.getOptionsPagination);

    if (this.$route.query.user_id && this.getUser.super_admin) {
      this.filter.user_id = this.$route.query.user_id;
    } else {
      delete this.filter.user_id;
    }

    this._debouncedSearch = this.debounce(async () => { await this.makeSearch(true); }, 350);
    if(!this.filter.created_from && !this.filter.created_to){
      await this.makeSearch(true);
    }
  },
  watch: {
    'filter.status':      function(){ this._debouncedSearch(); },
    'filter.refund_type': function(){ this._debouncedSearch(); },
    'filter.customer_q':  function(){ this._debouncedSearch(); },
  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
      'getFilter':'cancellations/getFilter',
      'getOptionsPagination':'cancellations/getOptionsPagination',
    }),
    isSuperAdmin(){
      return (this.getUser && this.getUser.super_admin) ? this.getUser.super_admin : false;
    },
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'cancellations/index',
      'deleteItem': 'cancellations/delete',
      'massiveDeleteItem': 'cancellations/massDelete',
      'setFilter': 'cancellations/setFilter',
      'setOptionsPagination': 'cancellations/setOptionsPagination',
    }),

    debounce(fn, wait){
      var t=null; return function(){ var ctx=this,args=arguments;
        clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx,args); }, wait);
      };
    },

    onCreatedChange(payload){
      this.filter.created_from = payload.from;
      this.filter.created_to   = payload.to;
      this._debouncedSearch();
    },
    async resetFilter(){
      this.filter = {
        status : null,
        refund_type: null,
        customer_q: null,
        created_from: null,
        created_to: null,
      };

      this.createdFilter = { from: null, to: null };

      this.options_pagination = {
        page: 1,
        limit: 10
      };

      await this.makeSearch(true);
    },
    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      this.items = results.results
      this.items_count = results.count
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id) {
      this.$router.push(this.pathEdit + id)
    },

    confirmRemove(id) {
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove() {
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode) {
      if (this.typeDelete == 'single') {
        await this.remove(mode)
      } else if (this.typeDelete == 'massive') {
        await this.massiveRemove(mode)
      } else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode) {

      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id: this.ids_to_delete[0]})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode) {
      if (!mode) {

        this.modalDelete = false

      } else {

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id: {$in: this.ids_to_delete}})

        if (result.success) {

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter: this.filter, pagination: this.options_pagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        } else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async getNewPage() {
      await this.makeSearch()
    },
    calculatePagination(count, limit) {

      var divide = (count / limit)
      var rest = divide % 1

      if (rest > 0) {
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    getStatus(status, type) {

      if (status == 'completed') {
        return (type == 'name') ? 'Completato' : 'success'
      }else if (status == 'pending') {
        return (type == 'name') ? 'In attesa' : 'primary'
      }

    },
    getTypeCancellation(type){
      if(type == 'nothing'){
        return 'Nessuno'
      }else if( type == 'fixed'){
        return 'Importo Fisso'
      }else if( type == 'promo_code'){
        return 'Promo Code'
      }
    },

    getSlot(date, slot_id) {
      var string_date = new Date(date).toLocaleDateString()
      var split = slot_id.split(';')
      string_date += ' | ' + split[3] + ' - ' + split[4]
      return string_date
    },

    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
  },
  mounted() {

  },
}
</script>
